export default __webpack_public_path__ + "static/media/electric-meter-burnout.2e950291.png";